import Model from '@/class/cargo/model/utils/Model'

class TransportMethod {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'TransportMethod'
export const WATERWAY = new TransportMethod('WATERWAY', '水路', 'Waterway')
export const RAILWAY = new TransportMethod('RAILWAY', '铁路', 'Railway')
export const LAND_ROUTE = new TransportMethod('LAND_ROUTE', '陆路', 'Land route')
export const TYPES = [WATERWAY, RAILWAY, LAND_ROUTE]

/**
 * return null:没找到.
 */
export function getTransportMethodByCode(code) {
  return Model.getObjByCode(code, TYPES)
}

/**
 * return null:没找到.
 */
export function getTransportMethodByBusType(code, arrs) {
  return Model.getObjByCode(code, arrs)
}
